module.exports = __webpack_public_path__ + "20f18055e0c0f6ecf92684de57357260.jpg";